// pages/users/RetailersPage.jsx
import UserRolePage from './UserRolePage.jsx';
export default function RetailersPage() {
  return <UserRolePage role="retailer" title="Retailers" accentColor="#dc2626"
    roleOptions={['retailer']} />;
}
